import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { BillingAccount } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TData = Pick<BillingAccount, 'billingInfo' | 'currency' | 'currencyConfirmedAt'>;

export const useBillingAccount = (
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query billingAccount {
      billingAccount {
        currency
        currencyConfirmedAt
        billingInfo {
          firstName
          lastName
          address
          address2
          business
          businessName
          chamberOfCommerce
          city
          country
          firstName
          invoiceCcEmails
          invoiceEmails
          lastName
          postalCode
          state
          taxid
        }
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['billingAccount'],
    queryFn: async () =>
      client.request({
        data: {
          gql: graphql
        }
      })
  });
};
